/* MTHEME T04 bundle picker (quantity tiers 1/2/3, one size picker per pan, gifts shown per tier).
   Markup: blocks_t04.bundle_picker() inside a custom-liquid block of main-product. No brand strings here.
   Prices come from the product's own variants (JSON in the markup); tier discounts are Shopify automatic
   discounts (display only here). Gifts are reconciled by mt-gift-sync.js after every cart write. */
(function () {
  'use strict';
  function init(root) {
    if (root.__mtb) return; root.__mtb = true;
    var cfgEl = root.querySelector('script[data-mtb-cfg]');
    if (!cfgEl) return;
    var C = JSON.parse(cfgEl.textContent);
    var SIZES = C.sizes;            // [{label,id,price,compare}] prices in agorot
    var TIERS = C.tiers;            // {"1":{off:0},"2":{off:3900},"3":{off:9900}} agorot
    var T = C.text || {};
    var qty = C.start || 1;
    var def = Math.max(0, Math.min(SIZES.length - 1, C.default_size || 0));
    function ok(i) { return !!SIZES[i] && SIZES[i].avail !== false; }  // avail:false = sold out (shown, not selectable)
    if (!ok(def)) { for (var k = 0; k < SIZES.length; k++) { if (ok(k)) { def = k; break; } } }
    var sizes = [def, def, def];
    var rows = root.querySelectorAll('[data-row]');
    var totalEl = root.querySelector('[data-total]');
    var addBtn = root.querySelector('[data-add]');

    function money(a) { return '₪' + Math.round(a / 100).toLocaleString('he-IL'); }
    function calc(n) {
      var sub = 0, was = 0;
      for (var i = 0; i < n; i++) { sub += SIZES[sizes[i]].price; was += SIZES[sizes[i]].compare || SIZES[sizes[i]].price; }
      var off = (TIERS[n] && TIERS[n].off) || 0;
      return { now: sub - off, was: was, per: (sub - off) / n, off: off };
    }
    function pick(row, n) {
      var h = '';
      for (var s = 0; s < n; s++) {
        var label = n === 1 ? (T.size_label || '') : (T.pan_label || '#[i]').replace('[i]', s + 1);
        h += '<div class="mtb__pickrow"><span class="mtb__picklabel">' + label + '</span><div class="mtb__sizes" style="--mtb-n:' + SIZES.length + '" role="radiogroup" aria-label="' + label + '">';
        for (var i = 0; i < SIZES.length; i++) {
          var on = sizes[s] === i;
          if (!ok(i)) { h += '<button type="button" class="mtb__size is-soldout" role="radio" aria-checked="false" aria-disabled="true" disabled data-size="' + i + '"><span class="mtb__size-l">' + SIZES[i].label + '</span>' + (T.sold_out ? '<span class="mtb__soldtag">' + T.sold_out + '</span>' : '') + '</button>'; continue; }
          h += '<button type="button" class="mtb__size' + (on ? ' is-active' : '') + '" role="radio" aria-checked="' + on + '" data-slot="' + s + '" data-size="' + i + '">' + SIZES[i].label + '</button>';
        }
        h += '</div></div>';
      }
      row.querySelector('[data-pick]').innerHTML = h;
    }
    function render() {
      rows.forEach(function (row) {
        var n = parseInt(row.getAttribute('data-row'), 10), r = calc(n);
        row.querySelector('[data-now]').textContent = money(r.now);
        row.querySelector('[data-was]').textContent = money(r.was);
        var per = row.querySelector('[data-per]');
        if (per) { per.textContent = (T.per || '[price]').replace('[price]', money(r.per)); per.style.display = r.off ? '' : 'none'; }
        var pct = row.querySelector('[data-pct]'), sv = row.querySelector('[data-save]'), saved = r.was - r.now;
        if (pct) { var v = saved > 0 ? Math.round(saved * 100 / r.was) : 0; pct.textContent = v ? '-' + v + '%' : ''; pct.style.display = v ? '' : 'none'; }
        if (sv) { sv.textContent = saved > 0 ? (T.save || '[amount]').replace('[amount]', money(saved)) : ''; sv.style.display = saved > 0 ? '' : 'none'; }
      });
      if (totalEl) totalEl.textContent = money(calc(qty).now);
      root.dispatchEvent(new CustomEvent('mtb:change', { bubbles: true, detail: { qty: qty, sizes: sizes.slice(0, qty) } }));
    }
    function select(n) {
      qty = n;
      rows.forEach(function (row) {
        var on = parseInt(row.getAttribute('data-row'), 10) === n;
        row.classList.toggle('is-selected', on);
        row.querySelector('[data-choose]').setAttribute('aria-checked', on);
        if (on) pick(row, n); else row.querySelector('[data-pick]').innerHTML = '';
      });
      root.querySelectorAll('[data-gift-tier]').forEach(function (el) { el.hidden = String(el.getAttribute('data-gift-tier')) !== String(n); });
      render();
    }
    root.addEventListener('click', function (e) {
      var ch = e.target.closest('[data-choose]');
      if (ch && root.contains(ch)) { var n = parseInt(ch.getAttribute('data-choose'), 10); if (n !== qty) select(n); return; }
      var sz = e.target.closest('[data-slot]');
      if (sz && root.contains(sz)) {
        sizes[parseInt(sz.getAttribute('data-slot'), 10)] = parseInt(sz.getAttribute('data-size'), 10);
        sz.parentNode.querySelectorAll('.mtb__size').forEach(function (b) { var on = b === sz; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
        render();
      }
    });

    async function refreshDrawer() {
      var url = (window.routes && window.routes.cart_url) || '/cart';
      try {
        var html = await fetch(url + '?section_id=cart-drawer').then(function (r) { return r.text(); });
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer'), cur = document.getElementById('CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        document.querySelectorAll('.cart-count-bubble span:first-child').forEach(function (b) { b.textContent = cart.item_count < 100 ? cart.item_count : '99+'; });
        var drawer = document.querySelector('cart-drawer');
        if (drawer) { drawer.classList.remove('is-empty'); if (typeof drawer.open === 'function') { drawer.open(); return true; } }
      } catch (e) { /* fall through */ }
      return false;
    }

    addBtn && addBtn.addEventListener('click', async function () {
      var tally = {};
      for (var i = 0; i < qty; i++) { var id = SIZES[ok(sizes[i]) ? sizes[i] : def].id; tally[id] = (tally[id] || 0) + 1; }
      var items = Object.keys(tally).map(function (id) { return { id: parseInt(id, 10), quantity: tally[id] }; });
      var label = addBtn.querySelector('[data-add-text]'), prev = label ? label.textContent : '';
      addBtn.disabled = true; if (label) label.textContent = T.adding || prev;
      try {
        var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
        if (!r.ok) throw new Error('add ' + r.status);
        if (window.mtGiftSync) await window.mtGiftSync({ render: false });
        var opened = await refreshDrawer();
        if (!opened) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        if (label) label.textContent = prev; addBtn.disabled = false;
      } catch (err) {
        console.error('bundle add failed', err);
        if (label) label.textContent = T.error || prev;
        setTimeout(function () { if (label) label.textContent = prev; addBtn.disabled = false; }, 2000);
      }
    });

    select(qty);

    var timer = root.querySelector('[data-timer]');
    if (timer) {
      var hE = timer.querySelector('[data-h]'), mE = timer.querySelector('[data-m]'), sE = timer.querySelector('[data-s]');
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
        var d = Math.max(0, Math.floor((end - now) / 1000));
        hE.textContent = pad(Math.floor(d / 3600)); mE.textContent = pad(Math.floor((d % 3600) / 60)); sE.textContent = pad(d % 60);
      };
      tick(); setInterval(tick, 1000);
    }
  }
  function boot() { document.querySelectorAll('.mtb').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
